const mr = {

  // ======================================
// NAVBAR
// ======================================

"navbar.phone":
  "📞 हेल्पलाईन: +91 9876543210",

"navbar.email":
  "✉ chdNimon@gmail.com",

"navbar.adminLogin":
  "प्रशासन लॉगिन",

"navbar.digitalPortal":
  "डिजिटल सेवा पोर्टल",

"nav.home":
  "मुख्यपृष्ठ",

"nav.adminCommittee":
  "प्रशासकीय समिती",

"nav.citizenPortal":
  "नागरिक पोर्टल",

"nav.smartVillage":
  "स्मार्ट गाव",

"nav.rti":
  "माहिती अधिकार",

"nav.grievance":
  "तक्रार निवारण",

"nav.activity":
  "उपक्रम",

"nav.aboutus":
  "आमच्याबद्दल",

"nav.digitalLibrary":
  "डिजिटल वाचनालय",


"nav.schemes":
  "शासकीय योजना",

"nav.allNews":
  "सर्व बातम्या",

  "nav.otherCommittees":
  "इतर समित्या",

"otherCommittees.vhnwsc":
  "ग्राम आरोग्य पोषण पाणी पुरवठा व स्वच्छता समिती",

"otherCommittees.vwssc":
  "ग्राम पाणी पुरवठा व स्वच्छता समिती",

  "nav.declarations":
  "घोषणापत्रे",

// Dropdown

"birth":
  "जन्म प्रमाणपत्र",

"death":
  "मृत्यू प्रमाणपत्र",

"residence":
  "रहिवास प्रमाणपत्र",

"marriage":
  "विवाह प्रमाणपत्र",

"buildingPermit":
  "बांधकाम परवानगी",

"businessTrade":
  "व्यवसाय परवाना",

"property":
  "मालमत्ता कार्ड",

  // Navbar
  'nav.home': 'मुख्यपृष्ठ',
  'nav.adminCommittee': 'प्रशासकीय समिती',
  'nav.citizenPortal': 'नागरिक पोर्टल',
  'nav.smartVillage': 'स्मार्ट गाव',
  'nav.rti': 'माहितीचा अधिकार (RTI)',
  'nav.news': 'बातम्या',
  'nav.activity': 'कार्य',
  'nav.grievance': 'तक्रार',
  'nav.aboutus': 'आमच्याबद्दल',
  'nav.schemes': 'योजना',


  // Hero
  'hero.badge': '🏛️ ग्रामपंचायत निमोन खु',
  'hero.welcome': 'स्वागत',
  'hero.title': 'ग्रामपंचायत निमोन',
  'hero.desc': 'ग्रामपंचायत निमोन - ग्रामीण आणि शाश्वत विकासासाठी केंद्र',
  'hero.citizenLogin': 'नागरिक लॉगिन',
  'hero.moreKnow': 'अधिक जाणून घ्या',
  'hero.ministers': 'माननीय मंत्री व पदाधिकारी',
  'hero.gpOfficials': 'ग्रामपंचायत पदाधिकारी',

  'hero.minister1.name': 'मुख्यमंत्री देवेंद्र फडणवीस',
  'hero.minister1.role': 'मुख्यमंत्री, महाराष्ट्र',
  'hero.minister1.desc': 'ग्रामीण विकास आणि नागरिक सेवेसाठी नेतृत्व',
  'hero.minister2.name': 'उपमुख्यमंत्री एकनाथ शिंदे',
  'hero.minister2.role': 'उपमुख्यमंत्री, महाराष्ट्र',
  'hero.minister2.desc': 'ग्रामपंचायत सशक्तीकरण आणि डिजिटल सेवा',
  'hero.minister3.name': 'उपमुख्यमंत्री सुनेत्रा अजित पवार',
  'hero.minister3.role': 'उपमुख्यमंत्री, महाराष्ट्र',
  'hero.minister3.desc': 'ग्रामीण रस्ते, पाणीपुरवठा आणि महसूल सुधारणां',
  'hero.minister4.name': 'ओमकार पवार',
  'hero.minister4.role': 'मुख्य कार्यकारी अधिकारी, जिल्हा परिषद ',
  'hero.minister4.desc': 'ग्रामपंचायत बळकटी आणि 73व्या दुरुस्तीचे अंमलबजावणी',

  'hero.minister5.name': 'श्री. जयकुमार गोरे',
  'hero.minister5.role': 'माननीय मंत्री, ग्रामविकास आणि पंचायत राज ',
  // 'hero.minister5.desc': 'ग्रामपंचायत बळकटी आणि 73व्या दुरुस्तीचे अंमलबजावणी',
  'hero.minister6.name': 'श्री. योगेश कदम',
  'hero.minister6.role': 'माननीय राज्यमंत्री, ग्रामीण विकास आणि पंचायत राज, ',
  // 'hero.minister6.desc': 'ग्रामपंचायत बळकटी आणि 73व्या दुरुस्तीचे अंमलबजावणी',
  'hero.minister7.name': 'डॉ. चंद्रकांत पुलकुंडवार',
  'hero.minister7.role': 'सचिव, ग्रामविकास आणि पंचायत राज, ',
  // 'hero.minister7.desc': 'ग्रामपंचायत बळकटी आणि 73व्या दुरुस्तीचे अंमलबजावणी',


  'hero.official1.name': 'डॉ. सौ. स्वाती भाऊराव देवरे ',
  'hero.official1.role': 'सरपंच',
  'hero.official1.desc': 'ग्रामपंचायतचे प्रमुख',
  'hero.official2.name': 'सौ. सुगंधाबाई हिरामण खैरे',
  'hero.official2.role': 'उप सरपंच',
  'hero.official2.desc': 'महिला व बाल विकास सेवा',
  'hero.official3.name': 'श्री सचिन त्रम्बक सानप',
  'hero.official3.role': 'ग्रामपंचायत अधिकारी',
  'hero.official3.desc': 'नागरिक सेवा व योजना समन्वय',

  // Contact
  'contact.title': 'आपल्याला काही म्हणायचे आहे?',
  'contact.subtitle': 'आमच्याशी संपर्क साधा. आपली सूचना आणि तक्रारी.',
  'contact.tagline': 'संपर्क करा',
  'contact.sendMessage': 'संदेश पाठवा',
  'contact.responseTime': 'आम्ही 1–2 कामकाजाच्या दिवसांत उत्तर देऊ.',
  'contact.firstName': 'पहिले नाव',
  'contact.lastName': 'आडनाव',
  'contact.emailAddress': 'ईमेल पत्ता',
  'contact.emailPlaceholder': 'तुमचा ईमेल',
  'contact.subject': 'विषय',
  'contact.message': 'मेसेज',
  'contact.placeholderMessage': 'आपला संदेश येथे लिहा',
  'contact.subjectPlaceholder': 'विषय निवडा',
  'contact.submit': 'पाठवा',
  'contact.successTitle': 'संदेश पाठवला गेला!',
  'contact.successMessage': 'आपला संदेश यशस्वीरित्या पाठवला. आम्ही लवकर संपर्क करू.',

  'contact.phoneLabel': 'फोन',
  'contact.emailLabel': 'ईमेल',
  'contact.addressLabel': 'पत्ता',
  'contact.hoursLabel': 'वेळा',

  'contact.option.birth': 'जन्म प्रमाणपत्र',
  'contact.option.death': 'मृत्यू प्रमाणपत्र',
  'contact.option.residence': 'निवास प्रमाणपत्र',
  'contact.option.grievance': 'तक्रार नोंद',
  'contact.option.scheme': 'योजना',
  'contact.option.other': 'इतर',

  'contact.info.phone': '',
  'contact.info.email': '✉️ chdNimon@gmail.com ',
 'contact.info.address':
'ता. चांदवड, जि. नाशिक – 422306',
  'contact.info.hours': 'सोम–शनि, 10:00 ते 5:00',

  'modal.close': 'बंद करा',

  // Services
  'services.title': 'ऑनलाइन सेवा',
  'services.desc': 'सर्व प्रमाणपत्रे आणि सेवा एका ठिकाणी - ऑनलाइन अर्ज, ट्रॅकिंग आणि डाउनलोड',
  'services.birth.title': 'जन्म प्रमाणपत्र',
  'services.birth.desc': 'जन्म नोंदणी आणि प्रमाणपत्र डाउनलोड',
  'services.death.title': 'मृत्यू प्रमाणपत्र',
  'services.death.desc': 'मृत्यू नोंदणी सेवा',
  'services.residence.title': 'निवास प्रमाणपत्र',
  'services.residence.desc': 'निवास/पुरावा प्रमाणपत्र',
  'services.grievance.title': 'तक्रार नोंदणी',
  'services.grievance.desc': 'ग्रामपंचायतीकडे तक्रार नोंदवा',
  'services.news.title': 'बातम्या व अद्यतने',
  'services.news.desc': 'नवीन बातम्या व घोषणा',
  'services.payment.title': 'पेमेंट पोर्टल',
  'services.payment.desc': 'ऑनलाइन पेमेंट सुविधा',
  'services.onlineAvailable': 'ऑनलाइन उपलब्ध →',

  // Footer

  // 'navbar.phone': '📞 (02346) 243535',
  // 'navbar.email': '✉️ chdNimon@gmail.com',
  // 'navbar.adminLogin': 'प्रशासन लॉगिन',
  // 'navbar.digitalPortal': 'डिजिटल सेवा पोर्टल',
  // 'navbar.marathi': '🌐 मराठी',

  // 'navbar.phone': '📞 (02346) 243535',
  'navbar.email': '✉️ chdNimon@gmail.com',
  'navbar.adminLogin': 'प्रशासन लॉगिन',
  'navbar.digitalPortal': 'डिजिटल सेवा पोर्टल',
  'navbar.marathi': '🌐 मराठी',


  'lang.mr': 'मराठी',
  'lang.en': 'English',
  'switch.to': 'परिवर्तित करा',

  'footer.title': 'आपल्या विकासासाठी, आपल्या सेवेसाठी – ग्रामपंचायत निमोन',
  'footer.subtitle': 'ग्रामपंचायत निमोनचे अधिकृत वेबसाइट – नागरिकांसाठी माहिती, योजना आणि डिजिटल सेवा.',
  'footer.ctaTitle': 'त्वरित मदत आणि माहिती मिळवा',
  'footer.ctaText': 'प्रमाणपत्र, तक्रार किंवा योजनेसाठी आम्हाला आजच संपर्क करा.',
  'footer.ctaButton': '✉️ आम्हाला ईमेल करा',
  'footer.contact': 'संपर्क',
  'footer.quickLinks': 'द्रुत दुवे',
  'footer.officeHours': 'कार्यालय वेळा',
  'footer.copy': '© 2025 grampanchayathNimon Kh.com | Powered by Gram Panchayat Nimon Kh',
  'footer.bottom.location': 'महाराष्ट्र, भारत',
  'footer.officeHours.weekdays': 'सोम–शनि: 10:00 – 5:00',
  'footer.officeHours.saturday': 'शनिवार: 10:00 – 2:00',
  'footer.officeHours.sunday': 'रविवार: बंद',
  'footer.address': 'ग्रामपंचायत निमोन, ता., जि. नाशिक – 422306',

  //

// Admin Committee
//


"admin.hero.badge":
  "ग्रामपंचायत निमोन",

"admin.hero.title":
  "प्रशासकीय समिती",

"admin.hero.subtitle":
  "ग्रामपंचायत कार्यकारी मंडळ व प्रशासकीय विभाग",

"admin.stats.total":
  "एकूण सदस्य",

"admin.stats.senior":
  "वरिष्ठ नेतृत्व",

"admin.stats.elected":

  "निवडून आलेले सदस्य",



//
// Filters
//


"admin.filter.all":
  "सर्व",

"admin.filter.senior":
  "वरिष्ठ",

"admin.filter.officer":
  "अधिकारी",

"admin.filter.member":
  "सदस्य",

"admin.filter.staff":
  "कर्मचारी",


//
// Tiers
//


"admin.tier.senior":
  "वरिष्ठ नेतृत्व",

"admin.tier.officer":
  "प्रशासकीय अधिकारी",

"admin.tier.member":
  "समिती सदस्य",


"admin.tier.staff":
  "सहाय्यक कर्मचारी",



  
// RTI Section
//

"rti.title":
  "माहितीचा अधिकार",

"rti.subtitle":
  "सार्वजनिक माहिती पोर्टल",

"rti.heroText":
  "ग्रामपंचायतीची सार्वजनिक कागदपत्रे, प्रमाणपत्रे आणि माहिती पारदर्शकपणे पहा.",

//
// RTI Table Headers
//

"rti.table.colSr":
  "अ.क्र.",

"rti.table.colDoc":
  "दस्तऐवज",

"rti.table.colPeriod":
  "कालावधी",

"rti.table.colReceived":
  "प्राप्त",

"rti.table.colApproved":
  "मंजूर",

"rti.table.colRejected":
  "नाकारले",

"rti.table.colReason":
  "कारण",

//
// RTI Stats
//

"rti.stats.totalReceived":
  "एकूण प्राप्त",

"rti.stats.totalApproved":
  "एकूण मंजूर",

"rti.stats.totalRejected":
  "एकूण नाकारले",

//
// RTI Documents
//

"rti.documents.title":
  "RTI कागदपत्रे व प्रमाणपत्रे",

"rti.search.placeholder":
  "दस्तऐवज शोधा...",

"rti.noResults":
  "कोणतीही नोंद आढळली नाही",

//
// RTI Toolbar
//

"rti.downloadCSV":
  "CSV डाउनलोड",

"rti.downloadPDF":
  "PDF डाउनलोड",

"rti.pdfName":
  "माहिती अधिकार १ ते १७ नमुने ग्रामपंचायत निमोण माहिती",

"rti.print":
  "प्रिंट",

  // SmartVillage
  'smartvillage.badge': '🏡 ग्रामपंचायत पोर्टल',
  'smartvillage.pillar.smart': 'स्मार्ट',
  'smartvillage.pillar.village': 'गाव',
  'smartvillage.principles': 'डिजिटल ग्रामपंचायत मार्गदर्शक तत्त्वे आणि 5 मूलभूत आधारस्तंभ',
  'smartvillage.hero.title': 'स्मार्ट व्हिलेज',
  'smartvillage.hero.subtitle': 'निमोन',
  'smartvillage.hero.desc': 'डिजिटल तंत्रज्ञानाने सुसज्ज गाव — ई-सेवा, पारदर्शकता, नागरिक सहभाग आणि टिकाऊ विकास',
  'smartvillage.btn.learnMore': 'अधिक जाणून घ्या',
  'smartvillage.stats.pillars': '५ मूलभूत आधारस्तंभ',
  'smartvillage.stats.digital': 'डिजिटल सेवा',
  'smartvillage.stats.participation': 'नागरिक सहभाग',
  'smartvillage.stats.village': 'स्मार्ट ग्रामपंचायत',
  'smartvillage.section.eyebrow': 'Digital Village Initiative',
  'smartvillage.section.title': 'आमचे स्मार्ट प्रवास',
  'smartvillage.section.desc': 'डिजिटल ग्रामपंचायत मार्गदर्शक तत्त्वे आणि ५ मूलभूत आधारस्तंभ',
  'smartvillage.pillar.water.title': 'पाणी आणि आरोग्य',
  'smartvillage.pillar.water.desc': 'स्वच्छ आणि सुरक्षित पाणीपुरवठा सुनिश्चित करणे, स्वच्छतेसाठी प्रभावी उपाययोजना राबवणे आणि निरोगी जीवनशैलीसाठी जनजागृती वाढवणे.',
  'smartvillage.pillar.admin.title': 'प्रशासन व्यवस्थापन',
  'smartvillage.pillar.admin.desc': 'पारदर्शक, प्रभावी आणि जबाबदार कार्यशैली. शाश्वत योजना राबवणे, संसाधनांचे योग्य नियोजन आणि गावकऱ्यांच्या सहभागाने प्रशासन अधिक प्रभावी बनवणे.',
  'smartvillage.pillar.energy.title': 'ऊर्जा व्यवस्थापन',
  'smartvillage.pillar.energy.desc': 'विश्वसनीय वीजपुरवठा सुनिश्चित करणे, सौरऊर्जेसारख्या नवीकरणीय ऊर्जा स्रोतांचा वापर प्रोत्साहित करणे आणि पर्यावरणपूरक समुदाय घडवणे.',
  'smartvillage.pillar.education.title': 'शिक्षण व कौशल्य विकास',
  'smartvillage.pillar.education.desc': 'सर्व मुलांना दर्जेदार शिक्षण, साक्षरता दर सुधारणे आणि व्होकेशनल प्रोग्राम्स, डिजिटल लर्निंगद्वारे युवा व महिलांना सक्षम करणे.',
  'smartvillage.pillar.accountability.title': 'जवाबदारी व पारदर्शकता',
  'smartvillage.pillar.accountability.desc': 'सर्व निर्णय, निधी आणि विकास कार्ये सार्वजनिकांपर्यंत खुलेपणे पोहोचवणे. नागरिक सहभाग आणि नियमित अहवालाद्वारे विश्वासार्ह शासन.',
  'smartvillage.pillar.btn': 'जाणून घ्या →',

  // Activity
  'activity.hero.badge': '💧 वॉटर फाउंडेशन',
  'activity.hero.title': 'वॉटर कप 2017/2018 व गावातील जलसिद्धी',
  'activity.hero.sub': 'ग्रामपंचायत निमोन',

  'activity.1.tag': 'वॉटर कप 2018 (श्रद्धांद)',
  'activity.1.title': 'दुष्काळ संपवण्यासाठी 40 रात्री-40 दिवस श्रमदान',
  'activity.1.desc':
    'गावाला सतत भेडसावणारा दुष्काळ पूर्णपणे दूर करण्यासाठी ग्रामसभा रेडगाव कराणीच्या Water Foundation अंतर्गत (चित्रपट अभिनेता मा अमीरजी खान यांच्या सहभागाने) Water Cup 2017 स्पर्धेत सहभागी झाली आणि 40 सलग रात्री व दिवसांचे श्रमदान सुरू केले. Water Cup स्पर्धा 2018 अंतर्गत गावात झालेले काम: Nursery 2682–2700; Soil testing 203–203; Drainage pits 123–135; Labour 8046 घ.मी. (उपलब्ध 2000 घ.मी.)—Compartment banding; मशीनने झालेले काम 95700 घ.मी. (उपलब्ध 238025 घ.मी.); Area treatment 51874 घ.मी. (उपलब्ध 199650 घ.मी.); पाणी बचत तंत्रज्ञान: 14 हेक्टर → 100 हेक्टर; संरचनांचे संरक्षण: 4 → 4; Well refilling: 7 → 7.',

  'activity.2.tag': 'पेपरलेस ग्रामपंचायत',
  'activity.2.title': 'फॉर्म 1 ते 33 ऑनलाईन व प्रमाणपत्रे',
  'activity.2.desc':
    'रेडगाव खू ग्रामपंचायतीने जिल्ह्यात पहिली पेपरलेस ग्रामपंचायत म्हणून मान मिळवला आहे. याअंतर्गत ग्रामपंचायतचे फॉर्म 1 ते 33 ऑनलाईन केले जातात. नागरिकांना लागणारी सर्व प्रमाणपत्रे ऑनलाईन दिली जातात; तसेच 1965 पासून जन्म आणि मृत्यूची प्रमाणपत्रे दिली जातात. PAN CARD, उत्पन्न प्रमाणपत्र, नॉन-क्रिमीलेयर, वय, आदिवासी व इतर प्रकारची प्रमाणपत्रे ग्रामपंचायतच्याच स्तरावरून दिली जातात. तसेच वेळोवेळी येणाऱ्या सरकारी योजनांचे फॉर्मही ग्रामपंचायतीकडूनच भरले जातात.',

  'activity.3.tag': 'जलयुक्त शिवार योजना',
  'activity.3.title': 'जलयुक्त अंतर्गत पाझर तलाव व सिमेंट बंधारे दुरुस्ती',
  'activity.3.desc':
    'सरकारची एक महत्त्वाकांक्षी योजना म्हणजे जलयुक्त शिवार. या योजनेतून ग्रामपंचायत गावातील पाझर तलाव व सिमेंट धरणे/बंधारे दुरुस्त करते. त्यामुळे गावात पडणारे पावसाचे पाणी संकलित होऊन त्याचा फायदा लोकांना होतो. क्षेत्र दुष्काळमुक्त करण्यासाठी मोठ्या प्रमाणात वॉटरशेड कामे केली जात असून त्यामुळे भूजल पातळी वाढण्यास मदत होते. तसेच जनसहभागातून पाझर तलावातील गाळ काढून “गाळमुक्त बंधारे” आणि “गाळयुक्त शेतजमीन” ही संकल्पना राबवण्यात येते.',

  'activity.4.tag': 'स्वच्छ भारत अभियान',
  'activity.4.title': 'गावात 100% शौचालय बांधकाम',
  'activity.4.desc':
    'स्वच्छ भारत अभियान अंतर्गत गावाने सहभाग घेऊन 100% शौचालय बांधकाम पूर्ण केले आहे आणि रु. 12,000 इतका अनुदान मिळाले आहे. गावातील सर्व नागरिक शौचालयाचा नियमित वापर करतात.',

  'activity.5.tag': 'रोजगार हमी योजना',
  'activity.5.title': 'विहिरी, रस्ता काम व PMAY समर्थन',
  'activity.5.desc':
    'महाराष्ट्र रोजगार हमी योजनेअंतर्गत ग्रामपंचायतीमार्फत 14 विहिरी पूर्ण झाल्या आहेत, रस्त्याचे काम करण्यात आले आहे, तसेच बंधाऱ्यातील गाळ काढण्याचे कामही पूर्ण झाले आहे. तसेच प्रधानमंत्री आवास योजनेतील (घरकुल) लाभार्थ्यांना मजुरी दिली गेली आहे.',

  'activity.6.tag': 'पर्यावरणपूरक ग्राम संपन्नता',
  'activity.6.title': 'झाडे लावणे व संवर्धन',
  'activity.6.desc':
    'पर्यावरणपूरक ग्राम संपन्नता योजनेअंतर्गत गावात 500 झाडे लावण्यात आली आणि त्यांचे संवर्धन करण्यात आले.',

  'activity.7.tag': 'शेततळी',
  'activity.7.title': 'शेतकऱ्यांसाठी शेततळी',
  'activity.7.desc':
    'आतापर्यंत “मागेल त्याला शेततळे” या कार्यक्रमाअंतर्गत गावात 21 शेततळी बांधण्यात आली आहेत.',


  //
// About Us Updated
//

"about.hero.badge":
  "ग्रामपंचायत माहिती",

"about.hero.title":
  "ग्रामपंचायत निमोन",

"about.hero.sub":
  "ता. चांदवड, जि. नाशिक",

//
//
//
// Population
//

"population.badge":
  "ग्राम सांख्यिकी",

"population.title":
  "ग्रामपंचायत सांख्यिकी माहिती",

"population.subtitle":
  "ग्रामपंचायत लोकसंख्या व सुविधा माहिती",

"population.totalFamilies":
  "एकूण कुटुंब संख्या",

"population.scFemale":
  "SC महिला",

"population.scMale":
  "SC पुरुष",

"population.scTotal":
  "SC एकूण",

"population.stFemale":
  "ST महिला",

"population.stMale":
  "ST पुरुष",

"population.stTotal":
  "ST एकूण",

"population.otherFemale":
  "इतर महिला",

"population.otherMale":
  "इतर पुरुष",

"population.otherTotal":
  "इतर एकूण",

"population.bpl":
  "BPL कुटुंब",

"population.apl":
  "APL कुटुंब",

"population.privateToilet":
  "वैयक्तिक शौचालय",

"population.publicToilet":
  "सार्वजनिक शौचालय",

"population.primarySchool":
  "प्राथमिक शाळा",

"population.anganwadi":
  "अंगणवाडी केंद्र",

"population.society":
  "सहकारी सोसायटी",

"population.area":
  "भौगोलिक क्षेत्रफळ (हेक्टर)",

"population.farmers":
  "शेतकरी खातेदार संख्या",

//
// Village Information
//

//
// About Us Translation Fix
//

"about.population.title":
  "लोकसंख्या माहिती",

"about.population.total":
  "एकूण लोकसंख्या",

"about.population.male":
  "पुरुष",

"about.population.female":
  "महिला",

"about.population.families":
  "कुटुंबे",

//
// Village Information
//

"about.village.title":
  "गावाची माहिती",

"about.village.introduction.title":
  "प्रस्तावना",

"about.village.introduction.desc1":
  "ग्रामपंचायत निमोण ही चांदवड तालुका, जिल्हा नाशिक येथील एक महत्त्वाची स्थानिक स्वराज्य संस्था आहे. गावाच्या सर्वांगीण विकासासाठी ग्रामपंचायत कार्यरत असून स्वच्छता, पाणीपुरवठा, रस्ते, सार्वजनिक सुविधा आणि विविध शासकीय योजनांची अंमलबजावणी या कामांमध्ये ग्रामपंचायतीची महत्त्वाची भूमिका आहे. गावातील नागरिकांच्या सहकार्याने ग्रामपंचायत विकासकामे पार पाडत आहे...",

"about.village.introduction.desc2":
  "निमोण गाव निसर्गरम्य परिसरात वसलेले असून येथील मुख्य व्यवसाय शेती आणि दुग्धव्यवसाय आहे. गावातील शेतकरी मका, बाजरी, कांदा, द्राक्षे, भाजीपाला तसेच इतर हंगामी पिकांची मोठ्या प्रमाणावर शेती करतात. यामुळे गावाच्या आर्थिक प्रगतीला मोठा हातभार लागतो. शेतीसोबतच लघुउद्योग आणि पशुपालन हे देखील गावाच्या उत्पन्नाचे महत्त्वाचे स्रोत आहेत..",

"about.village.introduction.desc3":
  "निमोण गाव निसर्गरम्य परिसरात वसलेले असून येथील मुख्य व्यवसाय शेती आणि दुग्धव्यवसाय आहे. गावातील शेतकरी मका, बाजरी, कांदा, द्राक्षे, भाजीपाला तसेच इतर हंगामी पिकांची मोठ्या प्रमाणावर शेती करतात.",

"about.village.introduction.desc4":
  " यामुळे गावाच्या आर्थिक प्रगतीला मोठा हातभार लागतो. शेतीसोबतच लघुउद्योग आणि पशुपालन हे देखील गावाच्या उत्पन्नाचे महत्त्वाचे स्रोत आहेत.",

"about.village.introduction.desc5":
  "गावातील नागरिक मेहनती, साधे आणि संस्कृती जपणारे आहेत. वर्षभर विविध धार्मिक आणि सांस्कृतिक कार्यक्रम उत्साहाने साजरे केले जातात. कीर्तन, भजन, यात्रोत्सव, नवरात्र, शिवजयंती तसेच इतर सण-उत्सव गावात मोठ्या उत्साहात साजरे केले जातात. मराठी ही मुख्य भाषा असून काही ठिकाणी हिंदी आणि स्थानिक बोलीभाषाही वापरल्या जातात..",

"about.village.introduction.desc6":
  "भाषा असून काही ठिकाणी हिंदी आणि स्थानिक बोलीभाषाही वापरल्या जातात.रामपंचायत निमोण ही गावाच्या विकासासाठी कटिबद्ध असून स्वच्छ, सुरक्षित आणि प्रगत गाव घडविण्यासाठी ग्रामस्थांच्या सहकार्याने विविध योजना आणि उपक्रम राबवित आहे..",

//
// Saint Tradition
//

"about.village.saint.title":
  "भौगोलिक व सांस्कृतिक वैशिष्ट्ये",

"about.village.saint.desc1":
  "निसर्गरम्य परिसर – गावाभोवती हिरवाईने नटलेले डोंगर, शेतजमिनी व स्वच्छ वातावरण आढळते.",

"about.village.saint.desc2":
  " सुपीक जमीन – परिसरातील जमीन सुपीक असून विविध पिके घेण्यासाठी अनुकूल आहे.",

"about.village.saint.desc3":
  "सिंचन सुविधा – विहिरी, बोअरवेल व इतर सिंचन साधनांमुळे शेतीसाठी पाण्याची सोय उपलब्ध आहे.",

"about.village.saint.desc4":
  "शेतकरी प्रधान समाज – गावातील बहुसंख्य लोक शेती व शेतीपूरक व्यवसायावर अवलंबून आहेत.",

"about.village.saint.desc5":
  "समृद्ध सांस्कृतिक परंपरा – सण, उत्सव, जत्रा व पारंपरिक कार्यक्रम मोठ्या उत्साहात साजरे केले जातात.",

//
// Culture
//

"about.village.culture.title":
  "धार्मिक व सांस्कृतिक वारसा",

"about.village.culture.desc1":
  "सन १९९८ मध्ये श्रीलंकेतून आणलेली पंचधातूची बुद्ध मूर्ती बुद्ध विहारात स्थापित करण्यात आली.",

"about.village.culture.desc2":
  "खंडेराव यात्रा गेल्या २६ वर्षांपासून मोठ्या उत्साहात भरवली जाते.",

"about.village.culture.desc3":
  "गाव परिसरातील महानुभाव पंथाचे आश्रम अध्यात्मिक ज्ञानदानाचे कार्य करतात.",

//
// Development Works
//
//
// About - Development Section
//

"about.vikas.title":
  "विकास कामे",

"about.vikas.table.sr":
  "अ.क्र.",

"about.vikas.table.work":
  "कामाचे नाव",

"about.vikas.table.year":
  "वर्ष",

"about.vikas.table.amount":
  "निधी",

"about.vikas.table.status":
  "स्थिती",

"about.vikas.status.completed":
  "पूर्ण",

"about.vikas.status.progress":
  "प्रगतीत",

//
// Adarsh Village
//

"about.adarsh.title":
  "आदर्श गाव घटक",

"about.vikas.work.road":
  "रस्ता काँक्रीटीकरण",

"about.vikas.work.water":
  "पाणीपुरवठा योजना",

"about.vikas.work.anganwadi":
  "अंगणवाडी बांधकाम",

//
// Adarsh Village
//

"about.adarsh.cleanliness":
  "स्वच्छता",

"about.adarsh.cleanliness.desc":
  "स्वच्छता व जनजागृती उपक्रम",

"about.adarsh.water":
  "पाणीपुरवठा",

"about.adarsh.water.desc":
  "शुद्ध पिण्याच्या पाण्याची सुविधा",

"about.adarsh.education":
  "शिक्षण",

"about.adarsh.education.desc":
  "विद्यार्थ्यांसाठी शैक्षणिक सुविधा",

"about.adarsh.health":
  "आरोग्य",

"about.adarsh.health.desc":
  "आरोग्य सेवा व जनजागृती",

"about.adarsh.environment":
  "पर्यावरण",

"about.adarsh.environment.desc":
  "वृक्षारोपण व पर्यावरण संवर्धन",

  // Grievance 
  //
//
// Grievance Hero
//

"grievance.hero.badge":
  "ऑनलाइन तक्रार पोर्टल",

"grievance.hero.title":
  "आपली तक्रार नोंदवा",

"grievance.hero.sub":
  "पारदर्शक तक्रार व्यवस्थापन प्रणाली",

//
// Form Labels
//

"grievance.form.title":
  "तक्रार अर्ज",

"grievance.form.fullName.label":
  "पूर्ण नाव",

"grievance.form.fullName.placeholder":
  "आपले पूर्ण नाव लिहा",

"grievance.form.mobile.label":
  "मोबाईल नंबर",

"grievance.form.mobile.placeholder":
  "मोबाईल नंबर लिहा",

"grievance.form.aadhaar.label":
  "आधार क्रमांक",

"grievance.form.aadhaar.placeholder":
  "आधार क्रमांक लिहा",

"grievance.form.email.optionalLabel":
  "ईमेल पत्ता (पर्यायी)",

"grievance.form.email.placeholder":
  "ईमेल पत्ता लिहा",

"grievance.form.department.label":
  "विभाग निवडा",

"grievance.form.details.label":
  "तक्रारीचा तपशील",

"grievance.form.details.placeholder":
  "तक्रारीचे पूर्ण वर्णन लिहा",

"grievance.form.submit":
  "तक्रार नोंदवा",

"grievance.form.submitting":
  "सबमिट करत आहे...",

//
// Validation Errors
//

"grievance.form.error.fullName.required":
  "पूर्ण नाव आवश्यक आहे",

"grievance.form.error.mobile.required":
  "योग्य मोबाईल नंबर आवश्यक आहे",

"grievance.form.error.aadhaar.required":
  "योग्य आधार क्रमांक आवश्यक आहे",

"grievance.form.error.department.required":
  "कृपया विभाग निवडा",

"grievance.form.error.details.required":
  "तक्रारीचा तपशील आवश्यक आहे",

//
// Departments
//

"grievance.form.department.waterSupply":
  "पाणीपुरवठा",

"grievance.form.department.roadInfra":
  "रस्ते व पायाभूत सुविधा",

"grievance.form.department.health":
  "आरोग्य विभाग",

"grievance.form.department.education":
  "शिक्षण",

"grievance.form.department.agriculture":
  "कृषी",

"grievance.form.department.revenue":
  "महसूल",

"grievance.form.department.sanitation":
  "स्वच्छता",

"grievance.form.department.electricity":
  "वीज",

//
// Toast
//

"grievance.toast.success":
  "तक्रार यशस्वीरित्या नोंदवली",

"grievance.toast.error":
  "काहीतरी चूक झाली",

//
// Sidebar
//

"grievance.sidebar.officeContact.title":
  "कार्यालय संपर्क",

"grievance.sidebar.officeHours.title":
  "कार्यालय वेळा",

"grievance.sidebar.officeHours.mondayToFriday":
  "सोमवार - शुक्रवार",

"grievance.sidebar.officeHours.mondayToFriday.time":
  "सकाळी 10 ते संध्याकाळी 5",

"grievance.sidebar.officeHours.saturday":
  "शनिवार",

"grievance.sidebar.officeHours.saturday.time":
  "सकाळी 10 ते दुपारी 2",

"grievance.sidebar.officeHours.sunday":
  "रविवार",

"grievance.sidebar.officeHours.sunday.value":
  "बंद",

"grievance.sidebar.status.title":
  "तक्रार स्थिती",

"grievance.sidebar.status.pending":
  "प्रलंबित तक्रारी",

"grievance.sidebar.status.pending.value":
  "12",

"grievance.sidebar.status.followup":
  "फॉलो-अप प्रकरणे",

"grievance.sidebar.status.followup.value":
  "5",

  //
// Citizen Portal
//

"citizenPortal.hero.badge":
  "डिजिटल नागरिक सेवा",

"citizenPortal.hero.title":
  "नागरिक सेवा पोर्टल",

"citizenPortal.hero.desc":
  "सरकारी योजना, प्रमाणपत्रे आणि ऑनलाइन सेवा एका ठिकाणी मिळवा.",

//
// Search
//

"citizenPortal.search.placeholder":
  "योजना, विभाग किंवा सेवा शोधा...",

"citizenPortal.search.button":
  "शोधा",

//
// Categories
//

"citizenPortal.categories.title":
  "सेवा विभाग",

//
// Tabs
//

"citizenPortal.tabs.csc":
  "CSC सेवा",

"citizenPortal.tabs.dept":
  "विभागीय सेवा",

//
// Table Info
//

"citizenPortal.table.showing":
  "दाखवत आहे",

"citizenPortal.table.services":
  "सेवा",

"citizenPortal.table.for":
  "साठी",

"citizenPortal.table.status":
  "पोर्टल सुरू आहे",

"citizenPortal.table.empty":
  "कोणतीही सेवा उपलब्ध नाही",

//
// Table Columns
//

"citizenPortal.table.cols.no":
  "अ.क्र.",

"citizenPortal.table.cols.scheme":
  "योजना",

"citizenPortal.table.cols.dept":
  "विभाग",

"citizenPortal.table.cols.service":
  "सेवा",

"citizenPortal.table.cols.portal":
  "पोर्टल",

"citizenPortal.table.cols.website":
  "वेबसाइट",

//
// Mobile Labels
//

"citizenPortal.mobile.dept":
  "विभाग",

"citizenPortal.mobile.service":
  "सेवा",

"citizenPortal.mobile.website":
  "वेबसाइट",

  // QR Section
"citizenPortal.qr.houseTax":
  "घर कर",

"citizenPortal.qr.waterTax":
  "पाणी कर",

"citizenPortal.qr.note":
  "मोठा पाहण्यासाठी QR कोडवर क्लिक करा.",

"citizenPortal.qr.popup":
  "QR कोड स्कॅन करा",

  //
// Temple Section
//

"temple.heading":
  "प्रसिद्ध मंदिरे",

"temple.subheading":
  "निमोन येथील आध्यात्मिक व सांस्कृतिक मंदिरांचा अनुभव घ्या.",

"temple.location":
  "निमोन",

"temple.button":
  "अधिक पहा",

"temple.hanuman.name":
  "ग्रामदैवत हनुमान मंदिर",

"temple.yadavswami.name":
  "श्री संत यादव स्वामी महाराज मंदिर",

"temple.khanderao.name":
  "कुलदैवत श्री खंडेराव मंदिर",
  //
// Introduction Section
//

"intro.badge":
  "गावाची ओळख",

"intro.heading":
  "निमोन मध्ये आपले स्वागत आहे",

"intro.desc1":
  "नाशिक जिल्ह्यातील चांदवड तालुक्यातील निमोन हे ऐतिहासिक व सांस्कृतिक दृष्ट्या महत्त्वाचे गाव आहे. प्रभू रामचंद्र आणि छत्रपती शिवाजी महाराज यांच्या स्मृतींनी पावन झालेले हे गाव चांदवडपासून सुमारे १५ कि.मी. अंतरावर दुष्काळग्रस्त पूर्व भागात वसलेले आहे.",

"intro.desc2":
  "गावातील लोकांचा मुख्य व्यवसाय शेती असून शेती प्रामुख्याने पावसाच्या पाण्यावर अवलंबून आहे. कमी पाऊस आणि हंगामी शेतीमुळे अनेक कुटुंबांची आर्थिक परिस्थिती आव्हानात्मक आहे.",

"intro.desc3":
  "गावामध्ये आरोग्य, शिक्षण आणि रोजगाराच्या सुविधा मर्यादित आहेत. तरीसुद्धा निमोन येथील नागरिक विकास आणि उज्ज्वल भविष्यासाठी एकत्रितपणे प्रयत्न करत आहेत.",

"intro.button":
  "अधिक जाणून घ्या",

  // ======================================
// Birth Certificate
// ======================================

"birth.title":
  "जन्म प्रमाणपत्र",

"birth.backHome":
  "मुख्यपृष्ठावर जा",

"birth.card.title":
  "ग्रामपंचायत पोर्टलवरून जन्म प्रमाणपत्र मिळवा",

"birth.card.desc":
  "जन्म प्रमाणपत्रासाठी अर्ज सबमिट करा. अर्ज सबमिट केल्यानंतर तुम्हाला टोकन नंबर मिळेल तो जतन ठेवा.",

"birth.details.title":
  "जन्म दाखला",

"birth.fee":
  "शुल्क: ₹20",

"birth.documents":
  "आवश्यक कागदपत्रे",

"birth.doc1":
  "बाळाचा जन्म नोंद",

"birth.doc2":
  "पालकांचा आधार कार्ड",

"birth.doc3":
  "रुग्णालय प्रमाणपत्र",

"birth.process":
  "प्रक्रिया",

"birth.step1":
  "ऑनलाइन अर्ज करा",

"birth.step2":
  "कागदपत्रे अपलोड करा",

"birth.step3":
  "फी भरा",

"birth.step4":
  "प्रमाणपत्र डाउनलोड करा",

"birth.timeline":
  "कालावधी",

"birth.timelineValue":
  "२–३ दिवस",

"birth.ready":
  "अर्ज करण्यासाठी तयार आहात?",

"birth.apply":
  "अर्ज करा",


 // ======================================
// BIRTH CERTIFICATE FORM
// ======================================

"birthForm.step1.mr":
  "OTP सत्यापन",

"birthForm.step2.mr":
  "बाळाची माहिती",

"birthForm.step3.mr":
  "पालकांची माहिती",

"birthForm.step4.mr":
  "कागदपत्रे",

"birthForm.step5.mr":
  "पेमेंट",

"birthForm.step1.en":
  "सत्यापन",

"birthForm.step2.en":
  "बाळाची माहिती",

"birthForm.step3.en":
  "पालकांची माहिती",

"birthForm.step4.en":
  "कागदपत्रे",

"birthForm.step5.en":
  "पेमेंट",

"birthForm.mobile.title":
  "मोबाईल सत्यापन",

"birthForm.mobile.subtitle":
  "मोबाईल सत्यापन",

"birthForm.mobileNumber":
  "मोबाईल नंबर",

"birthForm.mobilePlaceholder":
  "मोबाईल नंबर टाका",

"birthForm.otp":
  "OTP",

"birthForm.otpPlaceholder":
  "OTP टाका",

"birthForm.verify":
  "OTP सत्यापित करा",

"birthForm.child.title":
  "बाळाची माहिती",

"birthForm.child.subtitle":
  "बाळाची माहिती",

"birthForm.childName":
  "बाळाचे नाव",

"birthForm.dob":
  "जन्म तारीख",

"birthForm.gender":
  "लिंग",

"birthForm.birthPlace":
  "जन्म ठिकाण",

"birthForm.genderMale":
  "पुरुष",

"birthForm.genderFemale":
  "स्त्री",

"birthForm.parent.title":
  "पालकांची माहिती",

"birthForm.parent.subtitle":
  "पालकांची माहिती",

"birthForm.fatherName":
  "वडिलांचे नाव",

"birthForm.motherName":
  "आईचे नाव",

"birthForm.address":
  "पत्ता",

"birthForm.documents.title":
  "कागदपत्रे",

"birthForm.documents.subtitle":
  "कागदपत्रे अपलोड करा",

"birthForm.payment.title":
  "पेमेंट",

"birthForm.payment.subtitle":
  "पेमेंट",

"birthForm.applicationFee":
  "अर्ज शुल्क",

"birthForm.success.title":
  "अर्ज यशस्वीरित्या सबमिट झाला!",

  // ======================================
// Birth Form
// ======================================

"birthForm.step1.title":
  "मोबाईल सत्यापन",

"birthForm.step1.subtitle":
  "सत्यापन",

"birthForm.step1.desc":
  "कृपया आपला मोबाईल नंबर टाका आणि OTP सत्यापित करा",

"birthForm.step1.sendOtp":
  "OTP पाठवा",

"birthForm.step1.verify":
  "सत्यापित करा →",

"birthForm.step2.title":
  "मुलाची माहिती",

"birthForm.step2.subtitle":
  "मुलाची माहिती",

"birthForm.step3.title":
  "पालकांची माहिती",

"birthForm.step3.subtitle":
  "पालकांची माहिती",

"birthForm.step4.title":
  "कागदपत्रे अपलोड करा",

"birthForm.step4.subtitle":
  "कागदपत्रे",

"birthForm.step5.title":
  "पेमेंट",

"birthForm.step5.subtitle":
  "पेमेंट प्रक्रिया",

"birthForm.success.title":
  "अर्ज यशस्वी!",


"birthForm.success.subtitle":
  "अर्ज यशस्वीरित्या सबमिट झाला",

"birthForm.token":
  "टोकन नंबर",

"birthForm.home":
  "मुख्यपृष्ठावर जा",

"birthForm.next":
  "पुढे",

"birthForm.back":
  "मागे",

"birthForm.pay":
  "पेमेंट करा व सबमिट करा",

"birthForm.top.title":
  "जन्म दाखला अर्ज",

"birthForm.top.subtitle":
  "जन्म दाखला अर्ज",

"birthForm.fee":
  "शुल्क",
  
// Death Certificate


"death.title":
  "मृत्यू प्रमाणपत्र",

"death.backHome":
  "मुख्यपृष्ठावर जा",

"death.card.title":
  "ग्रामपंचायत पोर्टलवरून मृत्यू प्रमाणपत्र मिळवा",

"death.card.desc":
  "मृत्यू प्रमाणपत्रासाठी अर्ज सबमिट करा. अर्ज सबमिट केल्यानंतर तुम्हाला टोकन नंबर मिळेल तो जतन ठेवा.",

"death.details.title":
  "मृत्यू दाखला",

"death.fee":
  "शुल्क: ₹20",

"death.documents":
  "आवश्यक कागदपत्रे",

"death.doc1":
  "मृतकाचा मृत्यू नोंद",

"death.doc2":
  "अर्जदाराचा आधार कार्ड",

"death.doc3":
  "रुग्णालय प्रमाणपत्र",

"death.process":
  "प्रक्रिया",

"death.step1":
  "ऑनलाइन अर्ज करा",

"death.step2":
  "कागदपत्रे अपलोड करा",

"death.step3":
  "फी भरा",

"death.step4":
  "प्रमाणपत्र डाउनलोड करा",

"death.timeline":
  "कालावधी",

"death.timelineValue":
  "२–३ दिवस",

"death.ready":
  "अर्ज करण्यासाठी तयार आहात?",

"death.apply":
  "अर्ज करा",

 
// Death Form


"deathForm.step1.title":
  "मोबाईल सत्यापन",

"deathForm.step1.subtitle":
  "सत्यापन",

"deathForm.step1.desc":
  "कृपया आपला मोबाईल नंबर टाका आणि OTP सत्यापित करा",

"deathForm.step1.sendOtp":
  "OTP पाठवा",

"deathForm.step1.verify":
  "सत्यापित करा →",

"deathForm.step2.title":
  "मृताची माहिती",

"deathForm.step2.subtitle":
  "मृत व्यक्तीची माहिती",

"deathForm.step3.title":
  "माहिती देणाऱ्याची माहिती",

"deathForm.step3.subtitle":
  "माहिती देणाऱ्याची माहिती",

"deathForm.step4.title":
  "कागदपत्रे अपलोड करा",

"deathForm.step4.subtitle":
  "कागदपत्रे",

"deathForm.step5.title":
  "पेमेंट",

"deathForm.step5.subtitle":
  "पेमेंट प्रक्रिया",

"deathForm.success.title":
  "अर्ज यशस्वी!",

"deathForm.success.subtitle":
  "अर्ज यशस्वीरित्या सबमिट झाला",

// Residence Certificate


"residence.title":
  "रहिवास प्रमाणपत्र",

"residence.backHome":
  "मुख्यपृष्ठावर जा",

"residence.card.title":
  "ग्रामपंचायत पोर्टलवरून रहिवास प्रमाणपत्र मिळवा",

"residence.card.desc":
  "रहिवास प्रमाणपत्रासाठी अर्ज सबमिट करा. अर्ज सबमिट केल्यानंतर तुम्हाला टोकन नंबर मिळेल तो जतन ठेवा.",

"residence.details.title":
  "रहिवास दाखला",

"residence.fee":
  "शुल्क: ₹20",

"residence.documents":
  "आवश्यक कागदपत्रे",

"residence.doc1":
  "रहिवास नोंद",

"residence.doc2":
  "आधार कार्ड",

"residence.doc3":
  "पत्त्याचा पुरावा",

"residence.process":
  "प्रक्रिया",

"residence.step1":
  "ऑनलाइन अर्ज करा",

"residence.step2":
  "कागदपत्रे अपलोड करा",

"residence.step3":
  "फी भरा",

"residence.step4":
  "प्रमाणपत्र डाउनलोड करा",

"residence.timeline":
  "कालावधी",

"residence.timelineValue":
  "२–३ दिवस",

"residence.ready":
  "अर्ज करण्यासाठी तयार आहात?",

"residence.apply":
  "अर्ज करा",

  // ======================================
// BUILDING PERMIT
// ======================================

"building.title":
  "बांधकाम परवानगी प्रमाणपत्र",

"building.subtitle":
  "ग्रामपंचायतीकडून बांधकाम परवान्यासाठी ऑनलाइन अर्ज करा.",

"building.details":
  "बांधकाम परवाना तपशील",

"building.fee":
  "अर्ज शुल्क : ₹500",

"building.documents":
  "आवश्यक कागदपत्रे",

"building.doc1":
  "जमीन मालकी पुरावा",

"building.doc2":
  "इमारत नकाशा",

"building.doc3":
  "आर्किटेक्ट मंजुरी",

"building.doc4":
  "मालमत्ता कर पावती",

"building.process":
  "अर्ज प्रक्रिया",

"building.step1":
  "इमारत आराखडा सादर करा",

"building.step2":
  "आवश्यक कागदपत्रे अपलोड करा",

"building.step3":
  "साइट तपासणी",

"building.step4":
  "परवानगी मंजुरी",

"building.timeline":
  "प्रक्रिया कालावधी",

"building.timelineValue":
  "१० - १५ कार्य दिवस",

"building.applyTitle":
  "बांधकाम परवान्यासाठी अर्ज करा",

"building.applyDesc":
  "जलद आणि सुरक्षित ऑनलाइन अर्ज सेवा.",

"building.apply":
  "अर्ज करा",

// ======================================
// PROPERTY CERTIFICATE
// ======================================

"property.title":
  "मालमत्ता प्रमाणपत्र",

"property.subtitle":
  "ऑनलाइन सत्यापित मालमत्ता प्रमाणपत्र मिळवा.",

"property.details":
  "मालमत्ता प्रमाणपत्र तपशील",

"property.fee":
  "अर्ज शुल्क : ₹250",

"property.documents":
  "आवश्यक कागदपत्रे",

"property.doc1":
  "मालमत्ता कर पावती",

"property.doc2":
  "मालकी पुरावा",

"property.doc3":
  "विक्री करार प्रत",

"property.process":
  "अर्ज प्रक्रिया",

"property.step1":
  "मालमत्ता फॉर्म भरा",

"property.step2":
  "कागदपत्रे अपलोड करा",

"property.step3":
  "तपासणी प्रक्रिया",

"property.step4":
  "प्रमाणपत्र मंजुरी",

"property.timeline":
  "प्रक्रिया कालावधी",

"property.timelineValue":
  "५ - ७ कार्य दिवस",

"property.applyTitle":
  "मालमत्ता प्रमाणपत्रासाठी अर्ज करा",

"property.apply":
  "अर्ज करा",

// ======================================
// PROPERTY CARD
// ======================================

"propertyCard.title":
  "मालमत्ता कार्ड",

"propertyCard.subtitle":
  "अधिकृत मालमत्ता कार्डसाठी ऑनलाइन अर्ज करा.",

"propertyCard.details":
  "मालमत्ता कार्ड तपशील",

"propertyCard.fee":
  "अर्ज शुल्क : ₹150",

"propertyCard.documents":
  "आवश्यक कागदपत्रे",

"propertyCard.doc1":
  "सर्वे क्रमांक",

"propertyCard.doc2":
  "मालकी कागदपत्र",

"propertyCard.doc3":
  "कर पावती",

"propertyCard.doc4":
  "ओळख पुरावा",

"propertyCard.process":
  "अर्ज प्रक्रिया",

"propertyCard.step1":
  "अर्ज सादर करा",

"propertyCard.step2":
  "आवश्यक कागदपत्रे अपलोड करा",

"propertyCard.step3":
  "तपासणी प्रक्रिया",

"propertyCard.step4":
  "मालमत्ता कार्ड मंजुरी",

"propertyCard.timeline":
  "प्रक्रिया कालावधी",

"propertyCard.timelineValue":
  "४ - ६ कार्य दिवस",

"propertyCard.applyTitle":
  "मालमत्ता कार्डसाठी अर्ज करा",

"propertyCard.apply":
  "अर्ज करा",
  // ======================================
// MARRIAGE CERTIFICATE
// ======================================

"marriage.title":
  "विवाह प्रमाणपत्र",

"marriage.subtitle":
  "ग्रामपंचायतीकडून विवाह प्रमाणपत्रासाठी ऑनलाइन अर्ज करा.",

"marriage.details":
  "विवाह प्रमाणपत्र तपशील",

"marriage.fee":
  "अर्ज शुल्क : ₹200",

"marriage.documents":
  "आवश्यक कागदपत्रे",

"marriage.doc1":
  "वधूचे आधार कार्ड",

"marriage.doc2":
  "वराचे आधार कार्ड",

"marriage.doc3":
  "लग्न पत्रिका",

"marriage.doc4":
  "लग्नाचा फोटो",

"marriage.process":
  "अर्ज प्रक्रिया",

"marriage.step1":
  "विवाह अर्ज फॉर्म पूर्ण करा",

"marriage.step2":
  "आवश्यक कागदपत्रे अपलोड करा",

"marriage.step3":
  "तपासणी प्रक्रिया",

"marriage.step4":
  "प्रमाणपत्र मंजुरी",

"marriage.timeline":
  "प्रक्रिया कालावधी",

"marriage.timelineValue":
  "५ - ७ कार्य दिवस",

"marriage.applyTitle":
  "विवाह प्रमाणपत्रासाठी अर्ज करा",

"marriage.applyDesc":
  "सुरक्षित आणि जलद ऑनलाइन विवाह प्रमाणपत्र अर्ज सेवा.",

"marriage.apply":
  "अर्ज करा",

  // ======================================
// MARRIAGE CERTIFICATE FORM
// ======================================

"marriageForm.top.title":
  "विवाह प्रमाणपत्र अर्ज",

"marriageForm.top.subtitle":
  "ऑनलाइन विवाह नोंदणी सेवा",

"marriageForm.fee":
  "अर्ज शुल्क : ₹५०",

// Steps
"marriageForm.step1.mr":
  "मोबाईल पडताळणी",

"marriageForm.step1.en":
  "Verification",

"marriageForm.step2.mr":
  "विवाह माहिती",

"marriageForm.step2.en":
  "Marriage Details",

"marriageForm.step3.mr":
  "वधू-वर माहिती",

"marriageForm.step3.en":
  "Bride & Groom",

"marriageForm.step4.mr":
  "कागदपत्रे",

"marriageForm.step4.en":
  "Documents",

"marriageForm.step5.mr":
  "पेमेंट",

"marriageForm.step5.en":
  "Payment",

// Step 1
"marriageForm.mobileVerification":
  "मोबाईल पडताळणी",

"marriageForm.mobile":
  "मोबाईल क्रमांक",

"marriageForm.mobilePlaceholder":
  "मोबाईल क्रमांक टाका",

"marriageForm.otp":
  "OTP",

"marriageForm.otpPlaceholder":
  "OTP टाका",

"marriageForm.verifyOtp":
  "OTP पडताळा",

// Step 2
"marriageForm.marriageDetails":
  "विवाह माहिती",

"marriageForm.marriageDate":
  "विवाह तारीख",

"marriageForm.marriagePlace":
  "विवाह स्थळ",

"marriageForm.registrationNumber":
  "नोंदणी क्रमांक",

"marriageForm.marriageType":
  "विवाह प्रकार",

"marriageForm.hindu":
  "हिंदू विवाह",

"marriageForm.court":
  "कोर्ट विवाह",

"marriageForm.other":
  "इतर",

// Step 3
"marriageForm.brideGroom":
  "वधू-वर माहिती",

"marriageForm.groomName":
  "वराचे नाव",

"marriageForm.brideName":
  "वधूचे नाव",

"marriageForm.address":
  "पत्ता",

// Step 4
"marriageForm.documents":
  "कागदपत्रे अपलोड करा",

// Step 5
"marriageForm.payment":
  "पेमेंट",

"marriageForm.applicationFee":
  "अर्ज शुल्क",

"marriageForm.paySubmit":
  "पेमेंट व सबमिट करा",

// Common
"marriageForm.next":
  "पुढे",

"marriageForm.back":
  "मागे",

"marriageForm.select":
  "-- निवडा --",

// Success
"marriageForm.successMr":
  "अर्ज यशस्वीरित्या पूर्ण झाला!",

"marriageForm.successEn":
  "विवाह प्रमाणपत्र अर्ज यशस्वीरित्या सबमिट झाला",

"marriageForm.token":
  "टोकन क्रमांक",

"marriageForm.home":
  "मुख्यपृष्ठावर जा",

  // ======================================
// DIGITAL LIBRARY
// ======================================

"digitalLibrary.hero.title":
  "डिजिटल लायब्ररी",

"digitalLibrary.hero.subtitle":
  "UPSC, MPSC आणि स्पर्धा परीक्षांसाठी मोफत शैक्षणिक साधने",

"digitalLibrary.videos.title":
  "शैक्षणिक व्हिडिओ",

"digitalLibrary.video1.title":
  "UPSC तयारी मार्गदर्शन",

"digitalLibrary.video2.title":
  "MPSC परीक्षा मार्गदर्शन",

"digitalLibrary.youtube.title":
  "लोकप्रिय यूट्यूब चॅनेल",

"digitalLibrary.newspapers.title":
  "दैनिक वर्तमानपत्रे",

"digitalLibrary.upscBooks.title":
  "UPSC अभ्यास साहित्य",

"digitalLibrary.mpscBooks.title":
  "MPSC अभ्यास साहित्य",

"digitalLibrary.openPdf":
  "PDF उघडा",
  // ======================================
// BUILDING PERMIT FORM
// ======================================

"permitForm.title":
  "बांधकाम परवाना अर्ज",

"permitForm.subtitle":
  "बांधकाम परवान्यासाठी ऑनलाइन अर्ज करा",

// Stepper
"permitForm.step1.mr":
  "अर्जदार माहिती",

"permitForm.step1.en":
  "Applicant",

"permitForm.step2.mr":
  "ओळख माहिती",

"permitForm.step2.en":
  "Identity",

"permitForm.step3.mr":
  "बांधकाम माहिती",

"permitForm.step3.en":
  "Building",

"permitForm.step4.mr":
  "पत्ता माहिती",

"permitForm.step4.en":
  "Address",

"permitForm.step5.mr":
  "कागदपत्रे अपलोड",

"permitForm.step5.en":
  "Documents",

// Buttons
"permitForm.next":
  "पुढे",

"permitForm.back":
  "मागे",

"permitForm.submit":
  "अर्ज सबमिट करा",

"permitForm.home":
  "मुख्यपृष्ठावर जा",

// Step 1
"permitForm.applicantName":
  "अर्जदाराचे नाव",

"permitForm.mobile":
  "मोबाईल क्रमांक",

// Step 2
"permitForm.aadhar":
  "आधार क्रमांक",

"permitForm.survey":
  "सर्वे क्रमांक",

// Step 3
"permitForm.plot":
  "प्लॉट क्रमांक",

"permitForm.buildingType":
  "बांधकाम प्रकार",

"permitForm.select":
  "-- निवडा --",

"permitForm.residential":
  "निवासी बांधकाम",

"permitForm.commercial":
  "व्यावसायिक बांधकाम",

// Step 4
"permitForm.area":
  "बांधकाम क्षेत्रफळ (चौ.फुट)",

"permitForm.address":
  "बांधकामाचा पत्ता",

// Step 5
"permitForm.upload":
  "आवश्यक कागदपत्रे अपलोड करा",

// Success
"permitForm.success":
  "अर्ज यशस्वीरित्या सबमिट झाला",

"permitForm.token":
  "अर्ज टोकन क्रमांक",

  // ======================================
// BUILDING PERMIT CERTIFICATE
// ======================================

"permit.badge":
  "बांधकाम परवानगी",

"permit.title":
  "बांधकाम परवाना प्रमाणपत्र",

"permit.subtitle":
  "ग्रामपंचायतीमार्फत उपलब्ध बांधकाम परवानगी आणि बांधकाम मंजुरी सेवेसाठी ऑनलाइन अर्ज करा.",

"permit.back":
  "मुख्यपृष्ठावर जा",


// DETAILS

"permit.details":
  "बांधकाम परवाना माहिती",

"permit.fee":
  "अर्ज शुल्क : ₹१००",


// DOCUMENTS

"permit.documents":
  "आवश्यक कागदपत्रे",

"permit.doc1":
  "जमीन मालकीचा पुरावा",

"permit.doc2":
  "बांधकाम नकाशा / मंजूर लेआउट",

"permit.doc3":
  "अर्जदाराचे आधार कार्ड प्रत",

"permit.doc4":
  "मालमत्ता कर पावती",


// PROCESS

"permit.process":
  "अर्ज प्रक्रिया",

"permit.step1":
  "ऑनलाइन बांधकाम परवाना अर्ज फॉर्म भरा",

"permit.step2":
  "सर्व आवश्यक कागदपत्रे अपलोड करा",

"permit.step3":
  "ग्रामपंचायतीमार्फत अर्ज पडताळणी",

"permit.step4":
  "अधिकृत अधिकाऱ्यामार्फत जागेची तपासणी",

"permit.step5":
  "बांधकाम परवाना मंजुरी व प्रमाणपत्र जारी",


// TIMELINE

"permit.timeline":
  "प्रक्रिया कालावधी",

"permit.timelineValue":
  "बांधकाम परवाना प्रमाणपत्र ७–१५ कामकाजाच्या दिवसांत दिले जाईल.",


// APPLY SECTION

"permit.applyTitle":
  "बांधकाम परवान्यासाठी अर्ज करा",

"permit.applyDesc":
  "आपली बांधकाम मंजुरी प्रक्रिया जलद आणि सुरक्षितपणे ऑनलाइन सुरू करा.",

"permit.apply":
  "आता अर्ज करा",

  // ======================================
// ALL NEWS
// ======================================

"allNews.title":
  "गावातील बातम्या व अपडेट्स",

"allNews.subtitle":
  "नवीन घोषणा, अपडेट्स आणि महत्त्वाच्या बातम्या",

"allNews.emptyTitle":
  "कोणतीही बातमी उपलब्ध नाही",

"allNews.emptyDesc":
  "प्रशासकाने अद्याप कोणतीही बातमी जोडलेली नाही.",

  // ======================================
// VHNWSC
// ======================================

"vhnwsc.logo":
  "आरोग्य",

"vhnwsc.title":
  "ग्राम आरोग्य पोषण पाणी पुरवठा व स्वच्छता समिती",

"vhnwsc.subtitle":
  "गावातील आरोग्य, पोषण, पाणी पुरवठा आणि स्वच्छता व्यवस्थापनासाठी कार्यरत समिती",

"vhnwsc.members":
  "समिती सदस्य",

// Roles
"vhnwsc.sarpanch":
  "सरपंच",

"vhnwsc.deputySarpanch":
  "उप सरपंच",

"vhnwsc.member":
  "सदस्य",

"vhnwsc.memberFemale":
  "सदस्या",

"vhnwsc.officer":
  "ग्रामपंचायत अधिकारी",

"vhnwsc.operator":
  "संगणक परिचालक",

  // ======================================
// VWSSC
// ======================================

"vwssc.logo":
  "पाणी",

"vwssc.title":
  "ग्राम पाणीपुरवठा व स्वच्छता समिती",

"vwssc.subtitle":
  "गावातील पाणी पुरवठा, स्वच्छता आणि आरोग्य व्यवस्थापनासाठी कार्यरत समिती",

"vwssc.members":
  "समिती सदस्य",

// Roles
"vwssc.sarpanch":
  "सरपंच",

"vwssc.deputySarpanch":
  "उप सरपंच",

"vwssc.member":
  "सदस्य",

"vwssc.memberFemale":
  "सदस्या",

"vwssc.officer":
  "ग्रामपंचायत अधिकारी",

"vwssc.operator":
  "संगणक परिचालक",
  // ======================================
// VCPC
// ======================================

"vcpc.logo":
  "बाल संरक्षण",

"vcpc.title":
  "ग्राम बाल संरक्षण समिती",

"vcpc.subtitle":
  "गावातील बालकांचे संरक्षण, शिक्षण, आरोग्य आणि सुरक्षिततेसाठी कार्यरत समिती",

"vcpc.members":
  "समिती सदस्य",

// Roles
"vcpc.sarpanch":
  "सरपंच",

"vcpc.deputySarpanch":
  "उप सरपंच",

"vcpc.member":
  "सदस्य",

"vcpc.memberFemale":
  "सदस्या",

"vcpc.officer":
  "ग्रामपंचायत अधिकारी",

"vcpc.operator":
  "संगणक परिचालक",

};

export default mr;

